export default function VideoSection({ videoRef, isPlaying, handlePlayClick }) {
  return (
    <section id="video" className={`w-full min-h-screen flex items-center`}>
      <div className="myContainer w-full">
        <div
          className={`w-full relative overflow-hidden rounded-[40px] flex justify-center items-center max-lg:min-h-[184px] lg:max-h-[500px]`}
        >
          <video
            className={`object-cover rounded-[40px] w-full max-lg:min-h-[184px] lg:max-h-[500px] h-full`}
            // onClick={handlePlayClick}
            ref={videoRef}
            src="/img/home/G&G App V2.1.mp4"
            poster="/img/home/pexels-product-school-1299359-2678468 1.png"
            controls
          ></video>
          {!isPlaying && ( // Show play button only if video is not playing
            <img
              className="absolute cursor-pointer"
              src="/img/home/playIcon.png"
              alt="Play Icon"
              onClick={handlePlayClick} // Handle click event
            />
          )}
          {!isPlaying && ( // Show the absolute div only if video is not playing
            <div
              className={`py-2 md:py-4 px-4 md:px-8 bg-[#7F7F7F33] backdrop-blur-[5px] absolute md:right-7 bottom-10 md:bottom-5 max-lg:hidden`}
            >
              <span className={`text-lg md:text-4xl font-bold text-white`}>
                چرا باید به ما بپیوندی؟
              </span>
            </div>
          )}
        </div>
        <div
          className={`flex max-md:flex-col justify-between items-center mt-5 gap-4 md:gap-[10%]`}
        >
          <p
            className={`text-lg text-myNeutral26 md:w-1/2 text-justify leading-loose tracking-wider`}
          >
            با پیوستن به ما، فرصتی فوق‌العاده پیدا می‌کنی تا با هر اقدام کوچک،
            مثل کاهش مصرف انرژی یا شرکت در فعالیت‌های محیط‌زیستی، تأثیری مثبت و
            بزرگ بر روی زمین بگذاری. در عین حال، می‌تونی فعالیت‌های جسمانی خودت
            رو افزایش بدی و با بهبود سلامتت، سبک زندگی شاداب‌تر و سالم‌تری رو
            تجربه کنی. علاوه بر این، تمام تلاش‌ها و مشارکت‌های ارزشمندت، با
            جوایز ویژه و افتخارات خاص پاداش داده می‌شه تا انگیزه بیشتری برای
            ادامه مسیر داشته باشی و از هر قدمی که برمی‌داری لذت ببری.
          </p>
          <div className={`flex flex-wrap gap-3 md:gap-4 w-full md:w-1/2`}>
            <div
              className={`bg-myGreen34/10 w-[calc(50%-2%)] rounded-[10px] h-[145px] md:h-[170px] flex justify-center items-center px-5 md:px-6`}
            >
              <span className={`text-myGreen34 text-lg md:text-2xl font-bold`}>
                تغییر مثبت ایجاد کن
              </span>
            </div>
            <div
              className={`bg-myGreen34/10 w-[calc(50%-2%)] rounded-[10px] h-[145px] md:h-[170px] flex justify-center items-center px-5 md:px-6`}
            >
              <span className={`text-myGreen34 text-lg md:text-2xl font-bold`}>
                سلامتت رو بهبود بده
              </span>
            </div>
            <div
              className={`bg-myGreen34/10 w-[calc(50%-2%)] rounded-[10px] h-[145px] md:h-[170px] flex justify-center items-center px-5 md:px-6`}
            >
              <span className={`text-myGreen34 text-lg md:text-2xl font-bold`}>
                جوایز ویژه بگیر
              </span>
            </div>
            <div
              className={`bg-myGreen34/10 w-[calc(50%-2%)] rounded-[10px] h-[145px] md:h-[170px] flex justify-center items-center px-5 md:px-6`}
            >
              <span className={`text-myGreen34 text-lg md:text-2xl font-bold`}>
                زمین رو نجات بده
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
